import React, { useMemo, useState, useEffect, useRef } from "react";
import "./Projects.css";

const PROJECTS = [
  {
    id: 1,
    title: "Kentsel Dönüşüm Projesi",
    location: "AKATLAR SOKAK NO: 7 / BAKIRKÖY",
    description: "Öncesi ve sonrası dönüşüm yapılan bölgede modern konut projesi.",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/1.jpeg", "/projects/2.jpeg"],
    image: "/projects/1.jpeg"
  },{
    id: 14,
    title: "Kentsel Dönüşüm Projesi",
    location: "BAKIRKÖY",
    description: "Yüce Tarla Caddesi",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/28.jpeg", "/projects/29.png"],
    image: "/projects/28.jpeg"
  },
  {
    id: 15,
    title: "Kentsel Dönüşüm Projesi",
    location: "Bakırköy",
    description: "Dr. Salih Zeki sokak",
    category: "KENTSEL DÖNÜŞÜM",
   images: ["/projects/30.jpg", "/projects/31.jpg"],
    image: "/projects/30.jpg"
  }, 
  {
    id: 2,
    title: "Kentsel Dönüşüm Projesi",
    location: "İNCİRLİ CADDESİ / BAKIRKÖY",
    description: "İŞ HANI",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/3.jpeg"],
    image: "/projects/3.jpeg"
  },  
  {
    id: 3,
    title: " Kentsel Dönüşüm Projesi",
    location: "YÜCE TARLA CD / BAKIRKÖY",
    description: "KARDELEN APT.",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/4.jpeg"],
    image: "/projects/4.jpeg"
  },
  {
    id: 4,
    title: "Kentsel Dönüşüm Projesi",
    location: "AKMESCİT SK / BAKIRKÖY",
    description: "ONLAR APT.",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/5.jpeg"],
    image: "/projects/5.jpeg"
  },
  {
    id: 5,
    title: "Kentsel Dönüşüm Projesi",
    location: "AYDIN SK / BAKIRKÖY",
    description: "No: 12",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/6.jpeg"],
    image: "/projects/6.jpeg"
  },
  {
    id: 6,
    title: "Kentsel Dönüşüm Projesi",
    location: "AYDIN SK / BAKIRKÖY",
    description: "No: 14",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/7.jpeg"],
    image: "/projects/7.jpeg"
  },
  {
    id: 7,
    title: "Kentsel Dönüşüm Projesi",
    location: "MAHMUT MORALI SK / BAKIRKÖY",
    description: "No: 15",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/8.jpeg"],
    image: "/projects/8.jpeg"
  },
  {
    id: 8,
    title: "Kentsel Dönüşüm Projesi",
    location: "AKMESCİT SK / BAKIRKÖY",
    description: "MERAL APT.",
    category: "KENTSEL DÖNÜŞÜM",
    images: ["/projects/9.jpeg"],
    image: "/projects/9.jpeg"
  },
  {
    id: 9,
    title: "Çocuk Aktivite Merkezi",
    location: "ESENLER",
    description: "ESENLER ÇOCUK AKTİVİTE MERKEZİ",
    category: "KAMU",
    images: ["/projects/10.jpeg", "/projects/11.jpeg", "/projects/12.jpeg"],
    image: "/projects/10.jpeg"
  },
  {
    id: 10,
    title: "ATEŞTUĞLA KÜTÜPHANESİ",
    location: "ATEŞTUĞLA / BAĞCILAR",
    description: "GENÇLİK MERKEZİ",
    category: "KAMU",
    images: ["/projects/13.jpeg", "/projects/14.jpeg", "/projects/15.jpeg", "/projects/16.jpeg", "/projects/17.jpeg"],
    image: "/projects/13.jpeg"
  },
  {
    id: 11,
    title: "AİLE SAĞLIĞI MERKEZİ",
    location: "MAHMUTBEY / BAĞCILAR",
    description: "MAHMUTBEY AİLE SAĞLIĞI MERKEZİ",
    category: "KAMU",
    images: ["/projects/18.jpeg", "/projects/19.jpeg"],
    image: "/projects/18.jpeg"
  },
  {
    id: 12,
    title: "MUHTARLIK",
    location: "ALTINTEPSİ / BAYRAMPAŞA",
    description: "BAYRAMPAŞA MUHTARLIK",
    category: "KAMU",
    images: ["/projects/20.jpeg", "/projects/21.jpeg"],
    image: "/projects/20.jpeg"
  },  {
    id: 13,
    title: "KÜLTÜR MERKEZİ",
    location: "ESENLER",
    description: "ÖNCESİ VE SONRASI RESTORASYON YAPILAN KÜLTÜR MERKEZİ",
    category: "KAMU",
    images: ["/projects/22.jpeg", "/projects/23.jpeg", "/projects/24.jpeg", "/projects/25.jpeg", "/projects/26.jpeg", "/projects/27.jpeg"],
    image: "/projects/22.jpeg"
  },  
];

const ProjectCard = ({ project, onImageClick }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const intervalRef = useRef(null);
  const isMultipleImages = project.images && project.images.length > 1;

  useEffect(() => {
    if (isMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
      }, 2000);
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [isMultipleImages, project.images.length]);

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + project.images.length) % project.images.length);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
      }, 4000);
    }
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
      }, 4000);
    }
  };

  const currentImage = project.images ? project.images[currentImageIndex] : project.image;

  return (
    <article className={`project-card ${project.id === 1 ? 'project-tall-image' : ''}`} onClick={() => onImageClick(project)}>
      <div className="project-cover-wrapper">
        <div
          className="project-cover"
          style={{ backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.05), rgba(0,0,0,0.3)), url(${currentImage})` }}
        />
        {isMultipleImages && (
          <>
            <button className="slider-btn prev-btn" onClick={handlePrev} aria-label="Önceki fotoğraf">
              ‹
            </button>
            <button className="slider-btn next-btn" onClick={handleNext} aria-label="Sonraki fotoğraf">
              ›
            </button>
            <div className="slider-indicators">
              {project.images.map((_, index) => (
                <span
                  key={index}
                  className={`indicator ${index === currentImageIndex ? "active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(index);
                  }}
                />
              ))}
            </div>
          </>
        )}
      </div>
      <div className="project-body">
        <h3>{project.title}</h3>
        <p className="project-location">{project.location}</p>
        <p className="project-desc">{project.description}</p>
      </div>
    </article>
  );
};

const Projects = () => {
  const categories = ["TÜMÜ", "KAMU", "KENTSEL DÖNÜŞÜM"];
  const [activeCategory, setActiveCategory] = useState("TÜMÜ");
  const [modalProject, setModalProject] = useState(null);
  const [modalImageIndex, setModalImageIndex] = useState(0);

  const filtered = useMemo(() => {
    let projects = activeCategory === "TÜMÜ" ? [...PROJECTS] : PROJECTS.filter((p) => p.category === activeCategory);
    
    // id 1, 10, 13'ü ilk 3 sıraya yerleştir
    const priorityIds = [1, 10, 13];
    const priorityProjects = projects.filter(p => priorityIds.includes(p.id));
    const otherProjects = projects.filter(p => !priorityIds.includes(p.id));
    
    // Priority projeleri id sırasına göre sırala (1, 10, 13)
    priorityProjects.sort((a, b) => {
      const indexA = priorityIds.indexOf(a.id);
      const indexB = priorityIds.indexOf(b.id);
      return indexA - indexB;
    });
    
    return [...priorityProjects, ...otherProjects];
  }, [activeCategory]);

  const openModal = (project) => {
    setModalProject(project);
    setModalImageIndex(0);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setModalProject(null);
    document.body.style.overflow = "auto";
  };

  const handleModalPrev = () => {
    if (modalProject) {
      setModalImageIndex((prev) => (prev - 1 + modalProject.images.length) % modalProject.images.length);
    }
  };

  const handleModalNext = () => {
    if (modalProject) {
      setModalImageIndex((prev) => (prev + 1) % modalProject.images.length);
    }
  };

  useEffect(() => {
    if (!modalProject) return;
    
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") {
        setModalImageIndex((prev) => (prev - 1 + modalProject.images.length) % modalProject.images.length);
      }
      if (e.key === "ArrowRight") {
        setModalImageIndex((prev) => (prev + 1) % modalProject.images.length);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [modalProject]);

  return (
    <section className="projects" id="projects">
      <h2>Projelerimiz</h2>

      <div className="projects-filter">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`filter-chip ${activeCategory === cat ? "active" : ""}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="projects-grid">
        {filtered.map((project) => (
          <ProjectCard key={project.id} project={project} onImageClick={openModal} />
        ))}
      </div>

      {modalProject && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal} aria-label="Kapat">
              ×
            </button>
            {modalProject.images.length > 1 && (
              <>
                <button className="modal-nav prev" onClick={handleModalPrev} aria-label="Önceki fotoğraf">
                  ‹
                </button>
                <button className="modal-nav next" onClick={handleModalNext} aria-label="Sonraki fotoğraf">
                  ›
                </button>
                <div className="modal-indicators">
                  {modalProject.images.map((_, index) => (
                    <span
                      key={index}
                      className={`indicator ${index === modalImageIndex ? "active" : ""}`}
                      onClick={() => setModalImageIndex(index)}
                    />
                  ))}
                </div>
              </>
            )}
            <img
              src={modalProject.images[modalImageIndex]}
              alt={modalProject.title}
              className="modal-image"
            />
            <div className="modal-info">
              <h3>{modalProject.title}</h3>
              <p className="modal-location">{modalProject.location}</p>
              <p className="modal-desc">{modalProject.description}</p>
              <p className="modal-counter">
                {modalImageIndex + 1} / {modalProject.images.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;